import React from 'react';
import { EventCard } from '@sympla/sympla-components';
import { createPropsToTrackingMatrix } from 'components/Integration/createPropsToTrackingMatrix';
import {
  cardTypeTrackingSearch,
  componentTrackingSearch,
  typeTrackingSearch
} from 'constants/search';
import { MATRIX_TYPE } from 'constants/index';

interface AlgoliaSearchHitProps {
  hit: IHit;
  tagCard?: string;
  highlight?: boolean;
  layoutCard?: string;
}

export function AlgoliaSearchHit({
  hit,
  tagCard,
  highlight = false,
  layoutCard = 'lateral-on-mobile'
}: AlgoliaSearchHitProps) {
  const {
    objectID,
    name,
    organizer,
    images,
    event_url,
    start_date,
    end_date,
    __position,
    location,
    start_date_formats,
    end_date_formats,
    type
  } = hit;
  const formattedStartDate = start_date * 1000;
  const formattedEndDate = end_date * 1000;

  const { dataCreative } = createPropsToTrackingMatrix(__position, {
    trackingPrefix: MATRIX_TYPE.SEARCH,
    matrizTemplate: '',
    dataLocation: null,
    cardType: cardTypeTrackingSearch.eventCardSearch,
    componentTemplate: componentTrackingSearch.term,
    type: typeTrackingSearch.event,
    payloadCard: hit
  });

  const numberId = objectID.replace(/\D/g, '');
  return (
    <EventCard
      id={numberId}
      name={name}
      images={images}
      sectionPosition={__position}
      dataCreative={dataCreative}
      location={{
        name: location?.name,
        city: location?.city,
        state: location?.state
      }}
      organizer={organizer}
      type={type}
      url={event_url}
      data
      start_date={`${new Date(start_date).toISOString().slice(0, 19)}${new Date(
        formattedStartDate
      )
        .toISOString()
        .slice(23)}`}
      start_date_formats={start_date_formats}
      end_date={new Date(formattedEndDate).toISOString()}
      end_date_formats={end_date_formats}
      layoutCard={layoutCard}
      tagCard={tagCard}
      highlight={highlight}
    />
  );
}
